module.exports = __webpack_public_path__ + "static/media/Assyrian_icon_200px.e9970f55.png";